/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Who4_LinkInputs */

const en_dr_who4_link = /** @type {(inputs: Dr_Who4_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the Facilitator plan`)
};

const id_dr_who4_link = /** @type {(inputs: Dr_Who4_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat paket Fasilitator`)
};

/**
* | output |
* | --- |
* | "See the Facilitator plan" |
*
* @param {Dr_Who4_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_who4_link = /** @type {((inputs?: Dr_Who4_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Who4_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_who4_link(inputs)
	return en_dr_who4_link(inputs)
});